import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SummaryComponent, SummaryTitleProjectionDirective, SummaryBadgeProjectionDirective} from './summary.component';
import {ExpandableContentModule} from "../expandable-content/expandable-content.module";
import {ButtonModule} from "../button/button.module";
import {MatExpansionModule} from '@angular/material/expansion';
import {BadgeModule} from "../badge/badge.module";
import {TablerIconsModule} from "angular-tabler-icons";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ExpandableContentModule,
        ButtonModule,
        MatExpansionModule,
        BadgeModule,
        TablerIconsModule,

    ],
    declarations: [
        SummaryComponent,
        SummaryTitleProjectionDirective,
        SummaryBadgeProjectionDirective
    ],
    exports: [
        SummaryComponent,
        SummaryTitleProjectionDirective,
        SummaryBadgeProjectionDirective
    ]
})
export class SummaryModule {}
